import { render, staticRenderFns } from "./NewHubModal.vue?vue&type=template&id=7f1e44c3&"
import script from "./NewHubModal.vue?vue&type=script&lang=js&"
export * from "./NewHubModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports